import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/services/detail/page";
import About from "../pages/about/page";
import Book from "../pages/book/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/services/:slug", element: <ServiceDetail /> },
  { path: "/about", element: <About /> },
  { path: "/book", element: <Book /> },
  { path: "*", element: <NotFound /> },
];

export default routes;